import { handleActions, combineActions } from 'redux-actions';
import * as actions from '../../../actions/analytics';

export interface AnalyticsState {
  isFetching: boolean;
}

export const initialState: AnalyticsState = {
  isFetching: false,
};

const analytics = handleActions(
  {
    [combineActions(
      actions.loadAnalytics,
      actions.analyticsLoaded,
      actions.track,
    ) as any]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
  initialState,
);

export default analytics;
